function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { List } from "./List";
import * as $array from "./Array";
/**
 * A version of [[List]] to hold children of the [[Container]].
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/common-elements/containers/} for more info
 */
export var Children = /*#__PURE__*/function (_List) {
  _inherits(Children, _List);
  var _super = _createSuper(Children);
  function Children(container) {
    var _this;
    _classCallCheck(this, Children);
    _this = _super.call(this);
    Object.defineProperty(_assertThisInitialized(_this), "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this), "_container", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_events", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    _this._container = container;
    _this._events = _this.events.onAll(function (change) {
      if (change.type === "clear") {
        $array.each(change.oldValues, function (x) {
          _this._onRemoved(x);
        });
      } else if (change.type === "push") {
        _this._onInserted(change.newValue);
      } else if (change.type === "setIndex") {
        _this._onRemoved(change.oldValue);
        _this._onInserted(change.newValue, change.index);
      } else if (change.type === "insertIndex") {
        _this._onInserted(change.newValue, change.index);
      } else if (change.type === "removeIndex") {
        _this._onRemoved(change.oldValue);
      } else if (change.type === "moveIndex") {
        _this._onRemoved(change.value);
        _this._onInserted(change.value, change.newIndex);
      } else {
        throw new Error("Unknown IListEvent type");
      }
    });
    return _this;
  }
  _createClass(Children, [{
    key: "_onInserted",
    value: function _onInserted(child, index) {
      child._setParent(this._container, true);
      var childrenDisplay = this._container._childrenDisplay;
      if (index === undefined) {
        childrenDisplay.addChild(child._display);
      } else {
        childrenDisplay.addChildAt(child._display, index);
      }
    }
  }, {
    key: "_onRemoved",
    value: function _onRemoved(child) {
      this._container._childrenDisplay.removeChild(child._display);
      this._container.markDirtyBounds();
      this._container.markDirty();
    }
    /**
     * Returns `true` if obejct is disposed.
     */
  }, {
    key: "isDisposed",
    value: function isDisposed() {
      return this._disposed;
    }
    /**
     * Permanently dispose this object.
     */
  }, {
    key: "dispose",
    value: function dispose() {
      if (!this._disposed) {
        this._disposed = true;
        this._events.dispose();
        $array.each(this.values, function (child) {
          child.dispose();
        });
      }
    }
  }]);
  return Children;
}(List);